// src/pages/CartPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';

import { useCart } from '../../hooks/useCart';
import CartItem from '../../components/cart/CartItem';
import CartSummary from '../../components/cart/CartSummary';
import EmptyCart from '../../components/cart/EmptyCart';

const CartPage = () => {
  const { cart } = useCart();

  if (cart.length === 0) return <EmptyCart />;

  return (
    <div className="cart-page">
      <div className="container">
        <h1 className="cart-title">Your Shopping Cart</h1>

        <div className="cart-layout">
          <div className="cart-items">
            {cart.map(item => (
              <CartItem key={item.id} item={item} />
            ))}
          </div>

          <div className="cart-sidebar">
            <CartSummary />
          </div>
        </div>

        <div className="cart-footer">
          <Link to="/shop" className="continue-shopping-btn">
            ← Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CartPage;